import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { AppProvider } from "@/context/AppContext";
import { Layout } from "@/components/site/Layout";
import Home from "@/pages/Home";
import CatalogPage from "@/pages/CatalogPage";
import Pacotes from "@/pages/Pacotes";
import DrRuidos from "@/pages/DrRuidos";
import Orcamento from "@/pages/Orcamento";
import OrdemServico from "@/pages/OrdemServico";
import OSView from "@/pages/OSView";
import Informativos from "@/pages/Informativos";
import Garantia from "@/pages/Garantia";
import Contato from "@/pages/Contato";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminOSEdit from "@/pages/admin/AdminOSEdit";

function App() {
  return (
    <div className="App">
      <AppProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/tratamento-de-ruidos" element={<CatalogPage group="R" />} />
              <Route path="/isolamento-termoacustico" element={<CatalogPage group="I" />} />
              <Route path="/diagnostico" element={<CatalogPage group="D" />} />
              <Route path="/pacotes" element={<Pacotes />} />
              <Route path="/dr-ruidos" element={<DrRuidos />} />
              <Route path="/orcamento" element={<Orcamento />} />
              <Route path="/ordem-de-servico" element={<OrdemServico />} />
              <Route path="/os/:token" element={<OSView />} />
              <Route path="/informativos" element={<Informativos />} />
              <Route path="/garantia" element={<Garantia />} />
              <Route path="/contato" element={<Contato />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/os/:id" element={<AdminOSEdit />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="top-center" richColors />
      </AppProvider>
    </div>
  );
}

export default App;
